/** @type {(node?: Node | null) => node is Element} */
const isElement = (node) => node?.nodeType === Node.ELEMENT_NODE;

/** @type {(node?: Node | null) => node is Text} */
const isTextNode = (node) => node?.nodeType === Node.TEXT_NODE;

const eraseSelection = () => {
  const selection = document.getSelection();
  if (
    selection === null ||
    selection.isCollapsed ||
    !isTextNode(selection.anchorNode) ||
    !isTextNode(selection.focusNode)
  ) {
    return;
  }

  let start = selection.anchorNode.splitText(selection.anchorOffset);
  let end = selection.focusNode.splitText(
    selection.focusOffset,
  ).previousSibling;

  if (selection.direction === "backward") {
    [start, end] = [end, start];
    start = start.nextSibling;
    end = end.previousSibling;
  }

  let seenStart = false;
  let seenEnd = false;
  const root = selection.getRangeAt(0).commonAncestorContainer;
  const walker = document.createTreeWalker(
    root,
    NodeFilter.SHOW_TEXT,
    (node) => {
      seenStart ||= node === start;
      const inRange = seenStart && !seenEnd;
      seenEnd ||= node === end;
      return inRange
        ? node.parentElement?.closest("span.erased")
          ? NodeFilter.FILTER_REJECT
          : NodeFilter.FILTER_ACCEPT
        : NodeFilter.FILTER_SKIP;
    },
  );

  while (true) {
    const node = walker.currentNode;
    const nextNode = walker.nextNode();

    if (!isTextNode(node)) {
      if (!nextNode) {
        break;
      }
      continue;
    }

    const wrapped = document.createElement("span");
    wrapped.classList.add("erased");
    wrapped.textContent = node.textContent;
    wrapped.addEventListener("click", function (event) {
      event.stopPropagation();
      const parent = this.parentElement;
      this.replaceWith(this.textContent);
      parent?.normalize();
    });

    node.replaceWith(wrapped);
    wrapped.normalize();

    if (!nextNode) {
      break;
    }
  }

  start.parentNode?.normalize();
  end?.parentNode?.normalize();
  selection.empty();
};

/** @type {HTMLDivElement} */
const start = document.getElementById("start");
/** @type {HTMLTextAreaElement} */
const input = document.getElementById("input");
/** @type {HTMLButtonElement} */
const erase = document.getElementById("erase");
/** @type {HTMLDivElement} */
const erasing = document.getElementById("erasing");
/** @type {HTMLDivElement} */
const output = document.getElementById("output");
/** @type {HTMLButtonElement} */
const back = document.getElementById("back");
/** @type {HTMLButtonElement} */
const copy = document.getElementById("copy");
/** @type {HTMLButtonElement} */
const reset = document.getElementById("reset");

const copyInput = () => {
  output.innerHTML = input.value
    .split(/\n\n+/)
    .map((p) => `<p>${p.trim()}</p>`)
    .join("")
    .split(/\n+/)
    .join("<br>");
};

erase.addEventListener("click", () => {
  copyInput();
  start.style.display = "none";
  erasing.style.display = "block";
});

output.addEventListener("mouseup", eraseSelection);

back.addEventListener("click", () => {
  start.style.display = "block";
  erasing.style.display = "none";
});

copy.addEventListener("click", () => {
  /** @type {[Element, string][]} */
  const reverts = [];
  const walker = document.createTreeWalker(output, NodeFilter.SHOW_ELEMENT);
  while (true) {
    const node = walker.currentNode;
    const nextNode = walker.nextNode();
    if (isElement(node) && node.classList.contains("erased")) {
      reverts.push([node, node.textContent]);
      const initialSpaces = node.textContent.match(/^\s*/)[0];
      const finalSpaces = node.textContent.match(/\s*$/)[0];
      node.innerText = `${initialSpaces}~${node.textContent.trim()}~${finalSpaces}`;
    }
    if (!nextNode) {
      break;
    }
  }
  navigator.clipboard.writeText(output.innerText);
  for (const [node, text] of reverts) {
    node.innerText = text;
  }
});

reset.addEventListener("click", () => {
  copyInput();
});
